import { Award, Star, Medal, Rocket, Trophy, Flame, CalendarCheck } from "lucide-react";

export const BADGE_ICONS = {
  first_client: Award,
  five_clients: Star,
  ten_sessions: Medal,
  halfway: Rocket,
  goal_crushed: Trophy,
  week_streak: Flame,
  consistent: CalendarCheck,
};

export function badgeIcon(key) {
  return BADGE_ICONS[key] || Award;
}
